

(function ($) {

  'use strict';


  /*
   --------------------------------------------------
   SCROLL FUNCTION
   --------------------------------------------------
  */

  var scrollTo = function (targetId)
  {
    if (typeof targetId === 'undefined' || targetId === null || targetId.length === 0)
    {
        return false;
    }

    var $target = $(targetId);
    if ($target.length)
    {
        //iff fixed / sticky navigation
        var navOffset = 0;
        var $header = $('header.header');
        if ($header.length)
        {
            navOffset = $header.outerHeight();
        }

        var offset = $target.offset().top - navOffset;
        $('html,body').animate({ scrollTop: offset }, 1000);

        window.location.hash = targetId;
    }
    return true;
  };

  (function() {

    $(document).off('click.scrollto').on('click.scrollto', 
      'a[href*="#"]:not(a[href="#"]):not([data-toggle])',
      function (e)
      {
        if (window.location.pathname.replace('/^\//, \'\'') === this.pathname.replace('/^\//, \'\'') && window.location.hostname === this.hostname)
        {
          var targetId = this.hash;
          return scrollTo(targetId);
        }
        return true;
      });

  })();

  /*
   --------------------------------------------------
   SLIDESHOW
   --------------------------------------------------
  */
  (function() {

    var slideshow = $('.slideshow');

    var initSlideshow = function(slideshow) {
      slideshow.find('.slideshow__slides').slick({
        autoplay: (slideshow.attr('data-autoplay') === 'true'),
        autoplaySpeed: parseInt(slideshow.attr('data-cycle-speed')),
        fade: (slideshow.attr('data-animation-type') === 'fade'),
        adaptiveHeight: true,
        mobileFirst: true,
        accessibility: false,
        arrows: false,
        dots: true
      });
    }(slideshow);

    $(document).on('shopify:section:unload', '.shopify-section__slideshow', function(event) {
      $(event.target).find('.slideshow__slides').slick('unslick');
    });

    $(document).on('shopify:section:load', '.shopify-section__slideshow', function(event) {
      initSlideshow($(event.target).find('.slideshow'));
    });

    $(document).on('shopify:block:select', '.shopify-section__slideshow', function(event) {
      var currentSlide = $(event.target),
        slideshow = currentSlide.closest('.slideshow__slides');

      slideshow.slick('slickGoTo', currentSlide.attr('data-slide-index'));
      slideshow.slick('slickPause');
    });

    $(document).on('shopify:block:deselect', '.shopify-section__slideshow', function(event) {
      $(event.target).closest('.slideshow__slides').slick('slickPlay');
    });
  })();


  /*
   --------------------------------------------------
   Article Modal
   --------------------------------------------------
  */
  (function() {

    var articleModal = $('.article-modal');
    var articleRemodal = articleModal.remodal({hashTracking: false});

    $('body').on('click', '[data-action="article-modal"]', function(event) {
      articleRemodal.open();

      $.ajax($(this).attr('href')).then(function(result) {

        var headHtml = '<a href="#" class="modal__close" data-remodal-action="close"><svg class="icon icon-close-thin"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-close-thin"></use></svg></a>';
        var html = headHtml + result;
        
        articleModal.html(html);
      });

      window.articleRemodal = articleRemodal;
      event.preventDefault();
    });

    // When the modal is closed we need to re-add the small spinner
    $(document).on('closed', '.article-modal', function() {
      articleModal.html('<div class="article-modal__spinner spinner-container spinner-container--large"><div class="spinner spinner--circle"></div></div>');
      window.articleRemodal = null;
    });

  })();


  /*
   --------------------------------------------------
   JotForm
   --------------------------------------------------
  */
  (function() {

    

    $('a[href^="https://form.jotform.co/"]').fancybox({
      type: 'iframe',
      padding : 40,
      iframe : {
        scrolling : 'auto',
        preload   : false
      }
    });

  })();


  /*
   --------------------------------------------------
   Password Protect
   --------------------------------------------------
  */
  (function() {

    var protectModal = $('.protect-modal');
    if (protectModal.length === 0)
      return;

    var protectRemodal = protectModal.remodal({
      hashTracking: false, 
      closeOnConfirm: false, 
      closeOnCancel: false, 
      closeOnEscape: false, 
      closeOnOutsideClick: false 
    });     

    //cookie present (so ignore flow)
    if ($.cookie('landing-protect-isauthenticated'))
      return;

    //data attributes
    var isEnabled = protectModal.data('protect-enabled');
    var protect = protectModal.data('protect');
    
    //no password protection
    if (!isEnabled || protect == null || protect.length === 0)
      return;

    //password protect enabled
    protectRemodal.open();

    //form submit
    $('.protect-modal form[name="protect-form"]').submit(function(e)
    {
      var $form = $(e.currentTarget);
      //var data = $form.serialize();
      var submitted = $form.find('[name="protect-password"]').val();
      if (submitted != null && submitted.length)
      {
        if (submitted == protect)
        {
          $.cookie('landing-protect-isauthenticated', true, { expires: 1 });
          protectRemodal.close();
        }
        else
        {
          $('#protect-form-message').show().removeClass('error').addClass('error').text('Login failed! Please try again.');
        }
      }
      else
      {
        $('#protect-form-message').show().removeClass('error').addClass('error').text('Login failed! Please try again.');
      }
      return false;
    });

  })();


  

}(jQuery));